export default __webpack_public_path__ + "static/media/checkbox-inactive.8bc47a3b.svg";